<template>
    <div class="messages-control">
        <span class="nav-link">
            <span v-if="item.count !== undefined" class="nav-count-badge">
                {{ item.count }}
            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: "MessagesControl",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.nav-count-badge {
    background-color: #ff9922;
    color: white;
    font-size: 12px;
    font-weight: 600;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    margin-left: 26px;
}
</style>
